<template>
  <div>
    <PermissionValidation
      :marketId="marketId"
      rule="enableApproveCheckout"
    >
      <approve-list-contract-check-out :loading="isMainLoading" @onInit="getApproveTasksByMarket"></approve-list-contract-check-out>
    </PermissionValidation>
  </div>
</template>

<script>
import ApproveListContractCheckOut from "../../components/ApproveListContractCheckOut.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
export default {
  components: {
    ApproveListContractCheckOut,
    PermissionValidation
  },
  props: {
    isMainLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      marketId: this.$route.params.marketId
    };
  },
  methods: {
    getApproveTasksByMarket() {
      this.$emit("onGetApproveTasksByMarket");
    }
  }
};
</script>

<style>
</style>